import { keepPreviousData, useQuery } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { UsersWithSharesType } from "types/SharesTypes";

interface ApiResponse {
  status: "success";
  data: UsersWithSharesType[];
}

export default function useGetUsersWithShares(
  companyUuid?: string,
  enabled = true
) {
  return useQuery({
    queryKey: ["companies/users-with-shares", companyUuid],
    queryFn: async () => {
      return axiosInstance
        .get(`/companies/${companyUuid}/users-with-shares`)
        .then((res) => res.data);
    },
    placeholderData: keepPreviousData,
    select: (data: ApiResponse) => data.data,
    retry: false,
    enabled: !!companyUuid && enabled,
    staleTime: 1000 * 15,
  });
}
